































































































import { defineComponent, computed, onMounted, ref, watch } from '@vue/composition-api';
import { UserMetrics, UserMetricsPeriod } from '@/types';
import { useClient } from '@/use';

const jobsDataTableHeaders = [
  { text: 'User', value: 'user' },
  { text: 'Jobs Submitted', value: 'jobs' },
];
const framesDataTableHeaders = [
  { text: 'User', value: 'user' },
  { text: 'Frames Evaluated', value: 'frames' },
];
const videosDataTableHeaders = [
  { text: 'User', value: 'user' },
  { text: 'Videos Uploaded', value: 'videos' },
  { text: 'Storage Space Used (GB)', value: 'storage' },
];

const metricsPeriodItems: UserMetricsPeriod[] = ['mtd', 'ytd', 'from_inception'];

export default defineComponent({
  name: 'UserMetrics',
  setup() {
    const tab = ref(0);
    const client = useClient();
    const metricsPeriod = ref<UserMetricsPeriod>('from_inception');
    const userMetrics = ref<UserMetrics>();
    const loading = ref(false);

    async function fetchUserMetrics() {
      loading.value = true;
      userMetrics.value = await client.userMetrics(metricsPeriod.value);
      loading.value = false;
    }

    watch(metricsPeriod, fetchUserMetrics);
    onMounted(async () => {
      fetchUserMetrics();
    });

    const jobsPerUser = computed(() => {
      if (!userMetrics.value) {
        return [];
      }

      const obj = userMetrics.value.evaluation_jobs_submitted_per_user;
      return Object.keys(obj).map((user) => ({ user, jobs: obj[user] }));
    });

    const framesPerUser = computed(() => {
      if (!userMetrics.value) {
        return [];
      }

      const obj = userMetrics.value.individual_frames_evaluated_per_user;
      return Object.keys(obj).map((user) => ({ user, frames: obj[user] }));
    });

    const videosPerUser = computed(() => {
      if (!userMetrics.value) {
        return [];
      }

      const {
        videos_uploaded_per_user: uploaded,
        server_storage_space_used_by_each_user_in_GB: userStorage,
      } = userMetrics.value;

      return Object.keys(uploaded).map((user) => ({ user, videos: uploaded[user], storage: userStorage[user] }));
    });

    return {
      tab,
      metricsPeriod,
      metricsPeriodItems,
      userMetrics,
      fetchUserMetrics,
      loading,

      jobsDataTableHeaders,
      jobsPerUser,

      framesDataTableHeaders,
      framesPerUser,

      videosDataTableHeaders,
      videosPerUser,
    };
  },
});
